var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoofRegsDriver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.282,
    height: 30.815,
    viewBox: "0 0 32.282 30.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Emergency_Team",
    "data-name": "Total Emergency Team",
    transform: "translate(-390.089 -457.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(390.089 457.964)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.282,
    height: 30.815,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.282,
    height: 29.815,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-rescue-team-6623379",
    transform: "translate(395.749 462.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1.518,18.292H9.762a4.884,4.884,0,0,1,.306.565H1.212A4.851,4.851,0,0,1,1.518,18.292Zm7.759-.645H2a4.868,4.868,0,0,1,7.273,0Zm-8.3,1.839a.324.324,0,0,0,.1.017h9a.322.322,0,0,0,.206-.074,4.837,4.837,0,0,1,.163.7.2.2,0,0,1-.2.231H1.029a.2.2,0,0,1-.2-.23A4.831,4.831,0,0,1,.975,19.486Zm7.07-5.808a2.462,2.462,0,0,1-4.81,0Zm-5.06-1.357h5.31a.356.356,0,1,1,0,.712H2.985a.356.356,0,1,1,0-.712Zm5.208-.645H3.086a2.592,2.592,0,0,1,5.107,0Zm-2.876-1.31H4.889v.645h.429v.428h.645v-.428h.428v-.645H5.963V9.938H5.317ZM11.2,18.292h8.244a4.852,4.852,0,0,1,.306.565H10.893A4.851,4.851,0,0,1,11.2,18.292Zm7.759-.645H11.684a4.868,4.868,0,0,1,7.273,0ZM10.651,19.5h9.231a.321.321,0,0,0,.1-.017,4.827,4.827,0,0,1,.146.643.2.2,0,0,1-.2.231H10.71a.2.2,0,0,1-.2-.23A4.883,4.883,0,0,1,10.651,19.5Zm7.074-5.824a2.462,2.462,0,0,1-4.81,0Zm-5.06-1.357h5.31a.356.356,0,1,1,0,.712h-5.31a.356.356,0,1,1,0-.712Zm5.208-.645H12.767a2.592,2.592,0,0,1,5.107,0ZM15,10.318h-.4v.646H15v.4h.646v-.4h.4v-.646h-.4v-.4H15ZM10.48.595l4.393,1.883V6.029a5.128,5.128,0,0,1-4.233,5.032l-.16.028-.16-.028A5.128,5.128,0,0,1,6.088,6.029V2.477Zm.127.974a.323.323,0,0,0-.254,0L7.128,2.95a.323.323,0,0,0-.2.3V6.029a4.284,4.284,0,0,0,3.489,4.192.33.33,0,0,0,.118,0,4.284,4.284,0,0,0,3.49-4.192V3.246a.323.323,0,0,0-.2-.3Zm-.127.648,2.9,1.243v2.57a3.636,3.636,0,0,1-2.9,3.546,3.636,3.636,0,0,1-2.9-3.546V3.459ZM8.575,6.168,9.634,7.227a.472.472,0,0,0,.669,0c.909-.908,1.181-1.192,2.084-2.1a.472.472,0,0,0-.669-.666L9.969,6.223,9.245,5.5a.473.473,0,0,0-.669.669Z",
    fill: "#00b26b",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoofRegsDriver);
export default __webpack_public_path__ + "static/media/No of Regs Driver.6e76775b3727d4fb88346effd4af09f6.svg";
export { ForwardRef as ReactComponent };